import  { useMemo } from 'react'
import InvListBasic from './InvListBasic';
import { useCurrent, useFetch } from "../../hooks";
import CardHeader from '../card/CardHeader';
import { useTranslation } from 'react-i18next';

const InvListWidget = () => {
    const [t] = useTranslation('global')
    
    const {currentTenantId,currentCompanyId,currentBranchId} = useCurrent();

    const url = useMemo(() => {
        if(!currentTenantId || !currentCompanyId || !currentBranchId) return null;
        return `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
    }, [currentBranchId, currentCompanyId, currentTenantId]);

    const { data, loading } = useFetch(url);
    const invoices = data?.data;

    return (
        <div className="w-full">
            <div className='w-full rounded-2xl bg-white h-72 overflow-hidden flex flex-col border-2 border-violet-100'>
                <CardHeader className="text-[#251658] border-violet-100 px-2"> {t('DashBoard.latestInvoices')}  </CardHeader>
                <div className='flex-1 overflow-y-auto pt-1'>
                    <InvListBasic withBorder={false} withSummary={true} loading={loading} data={invoices}/>
                </div>
            </div>
        </div>
    )
}

export default InvListWidget
